(function () {
  'use strict';

  // Shared by both lp-bedtime-stickers-v1 and lp-bedtime-stickers-ridge via
  // snippets/lp-bedtime-stickers-buybox.liquid — extracted verbatim from
  // v1's original, stable implementation. Rooted at its own id so it works
  // identically no matter which page rendered the shared snippet.
  var root = document.getElementById('lpSpBuybox');
  if (!root) return;

  var CURRENCY = root.getAttribute('data-currency') || 'USD';

  function money(cents) {
    var amount = (parseInt(cents, 10) || 0) / 100;
    if (window.Intl && typeof Intl.NumberFormat === 'function') {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: CURRENCY,
          currencyDisplay: 'narrowSymbol'
        }).format(amount);
      } catch (e) { /* unsupported currency code — fall through */ }
    }
    return '$' + amount.toFixed(2);
  }

  var variantCards = root.querySelectorAll('.variant-card[data-pack]');
  var planButtons = root.querySelectorAll('.plan-box[data-plan]');
  var mainImage = root.querySelector('#buyboxMainImage');
  var thumbs = root.querySelectorAll('.buybox__thumb');
  var ctaLink = root.querySelector('#offer');
  var ctaLabel = ctaLink ? ctaLink.querySelector('[data-cta-label]') : null;
  var stickyPrice = root.querySelector('.sticky-cart-bar__now');
  var stickyMeta = root.querySelector('.sticky-cart-bar__meta');
  var stickyBtn = root.querySelector('.sticky-cart-bar__btn');
  var subBox = root.querySelector('.plan-box--sub');
  var subPriceEl = root.querySelector('[data-plan-price-sub]');
  var subCompareEl = root.querySelector('[data-plan-price-compare]');
  var planFlagEl = root.querySelector('[data-plan-flag]');
  var planSelect = root.querySelector('select[data-plan-input]');
  var oneTimePrice = root.querySelector('.plan-box--one .plan-box__price');

  // Frequency options per variant — {variantId: [{id, name, pct}, …]}. Built
  // once server-side from each variant's real selling_plan_allocations (see
  // the plan_map_json capture in lp-bedtime-stickers-buybox.liquid); a
  // variant absent or empty here has no subscription, ever.
  var planMapEl = root.querySelector('[data-plan-map]');
  var planMap = null;
  try { planMap = planMapEl ? JSON.parse(planMapEl.textContent) : null; } catch (e) { planMap = null; }
  var lastPlanVariant = null;

  var initialCard = root.querySelector('.variant-card--active') || variantCards[0];
  var initialPlan = root.querySelector('.plan-box--selected') || planButtons[0];
  var state = {
    pack: initialCard ? initialCard.getAttribute('data-pack') : null,
    plan: initialPlan ? initialPlan.getAttribute('data-plan') : 'subscribe'
  };

  function activeCard() {
    return root.querySelector('.variant-card[data-pack="' + state.pack + '"]') || variantCards[0];
  }

  function cartUrl(variantId, sellingPlanId) {
    if (!variantId) return '#offer';
    var addPath = '/cart/add?id=' + variantId + '&quantity=1';
    if (state.plan === 'subscribe' && sellingPlanId) {
      addPath += '&selling_plan=' + sellingPlanId;
    }
    addPath += '&return_to=/checkout';
    return '/cart/clear?return_to=' + encodeURIComponent(addPath);
  }

  // Rebuilds the frequency select's options from planMap[variantId] — only
  // when the pack actually changed, so choosing a frequency doesn't get
  // clobbered on every render() call. Tries to keep the shopper's chosen
  // frequency NAME (ids differ per variant even for "the same" cadence)
  // across the switch, else "Every 2 Months", else the first option.
  function repopulatePlans(variantId) {
    if (!planSelect || !planMap || variantId === lastPlanVariant) return;
    var currentName = planSelect.selectedOptions[0] ? planSelect.selectedOptions[0].textContent : null;
    lastPlanVariant = variantId;
    var list = planMap[variantId] || [];
    planSelect.innerHTML = '';
    var matchIdx = -1, defIdx = -1;
    list.forEach(function (p, i) {
      var o = document.createElement('option');
      o.value = p.id;
      o.setAttribute('data-pct', p.pct);
      o.textContent = (p.name || '').replace(/^every\s+/i, '');
      planSelect.appendChild(o);
      if (currentName && o.textContent === currentName) matchIdx = i;
      if (0 > defIdx && /every\s*2\s*month/i.test(p.name || '')) defIdx = i;
    });
    if (list.length) planSelect.selectedIndex = matchIdx >= 0 ? matchIdx : (defIdx >= 0 ? defIdx : 0);
  }

  function selectedPlanPct() {
    var opt = planSelect ? planSelect.selectedOptions[0] : null;
    return opt ? (parseInt(opt.getAttribute('data-pct'), 10) || 0) : 0;
  }

  // Every pack tile shows a price, so every pack tile has to follow the
  // Subscribe/One-time toggle, not just the summary line below the grid.
  // The ACTIVE tile gets the live, frequency-adjusted subscribe price
  // (activeSubscribeCents, computed in render() from whichever frequency is
  // selected); every other tile falls back to its own static data-subscribe-
  // cents (that variant's own "Every 2 Months" price) since it has no
  // frequency selector of its own to read from.
  function updatePackTiles(activeVariantId, activeSubscribeCents) {
    variantCards.forEach(function (card) {
      var isActive = card.getAttribute('data-variant-id') === activeVariantId;
      var oc = parseInt(card.getAttribute('data-onetime-cents'), 10) || 0;
      var sc = isActive ? activeSubscribeCents : (parseInt(card.getAttribute('data-subscribe-cents'), 10) || 0);
      var cc = parseInt(card.getAttribute('data-compare-cents'), 10) || 0;
      var patches = parseInt(card.getAttribute('data-patches'), 10) || 1;
      var shown = state.plan === 'subscribe' ? sc : oc;

      var priceEl = card.querySelector('[data-pack-price]');
      var compareEl = card.querySelector('[data-pack-compare]');
      var nightEl = card.querySelector('[data-pack-per-night]');
      if (priceEl) priceEl.textContent = money(shown);
      if (compareEl) {
        if (cc > shown) { compareEl.textContent = money(cc); compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
      if (nightEl) nightEl.textContent = money(Math.round(shown / patches));
    });
  }

  function render() {
    var card = activeCard();
    if (!card) return;

    var variantId = card.getAttribute('data-variant-id');
    var onetimeCents = parseInt(card.getAttribute('data-onetime-cents'), 10) || 0;
    var compareCents = parseInt(card.getAttribute('data-compare-cents'), 10) || 0;
    var pack = card.getAttribute('data-pack');
    var packLabel = pack + (pack === '1' ? ' pack' : ' packs');

    repopulatePlans(variantId);
    var hasPlan = !!(planMap && planMap[variantId] && planMap[variantId].length);

    // A pack with no real selling plan can never subscribe — force one-time
    // so the cart URL never carries a plan id the store hasn't allocated.
    if (!hasPlan && state.plan === 'subscribe') {
      state.plan = 'onetime';
      planButtons.forEach(function (btn) {
        var isOnetime = btn.getAttribute('data-plan') === 'onetime';
        btn.classList.toggle('plan-box--selected', isOnetime);
        btn.setAttribute('aria-checked', isOnetime ? 'true' : 'false');
      });
    }
    if (subBox) subBox.style.display = hasPlan ? '' : 'none';

    var pct = hasPlan ? selectedPlanPct() : 0;
    var sellingPlanId = hasPlan && planSelect.selectedOptions[0] ? planSelect.selectedOptions[0].value : null;
    var subscribeCents = Math.round(onetimeCents * (100 - pct) / 100);
    var price = state.plan === 'subscribe' ? subscribeCents : onetimeCents;
    var url = cartUrl(variantId, sellingPlanId);

    if (ctaLink) {
      // Sets the label SPAN's text, not the link's own textContent — the
      // link also holds the loading spinner as a sibling node, and
      // textContent would wipe that node out on every render().
      if (ctaLabel) ctaLabel.textContent = 'Add to cart — ' + money(price);
      ctaLink.setAttribute('href', url);
    }
    if (stickyPrice) stickyPrice.textContent = money(price);
    if (stickyBtn) stickyBtn.setAttribute('href', url);
    if (stickyMeta) {
      var pctOff = 0;
      if (compareCents > 0) {
        pctOff = Math.floor(((compareCents - price) / compareCents) * 100);
      }
      stickyMeta.textContent = packLabel + ' · ' +
        (state.plan === 'subscribe' ? pctOff + '% off' : 'One-time purchase');
    }
    if (hasPlan) {
      if (subPriceEl) subPriceEl.textContent = money(subscribeCents);
      if (subCompareEl) subCompareEl.textContent = money(onetimeCents);
      if (planFlagEl) planFlagEl.textContent = 'Extra ' + pct + '% off';
    }
    if (oneTimePrice) oneTimePrice.textContent = money(onetimeCents);

    updatePackTiles(variantId, subscribeCents);
  }

  function selectPack(pack) {
    state.pack = pack;
    variantCards.forEach(function (card) {
      var active = card.getAttribute('data-pack') === pack;
      card.classList.toggle('variant-card--active', active);
      card.setAttribute('aria-checked', active ? 'true' : 'false');
    });
    render();
  }

  function selectPlan(plan) {
    state.plan = plan;
    planButtons.forEach(function (btn) {
      var selected = btn.getAttribute('data-plan') === plan;
      btn.classList.toggle('plan-box--selected', selected);
      btn.setAttribute('aria-checked', selected ? 'true' : 'false');
    });
    render();
  }

  variantCards.forEach(function (card) {
    card.addEventListener('click', function () {
      selectPack(card.getAttribute('data-pack'));
    });
  });

  planButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      selectPlan(btn.getAttribute('data-plan'));
    });
    // plan-box--sub is a div with role=radio (it holds a real select element,
    // which can't nest inside a button), so it needs its own Enter/Space
    // handler to stay keyboard-operable the way a native button gets for free.
    if (btn.tagName !== 'BUTTON') {
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          if (e.target === planSelect) return; // let the select handle its own keys
          e.preventDefault();
          selectPlan(btn.getAttribute('data-plan'));
        }
      });
    }
  });

  if (planSelect) {
    planSelect.addEventListener('click', function (e) { e.stopPropagation(); });
    planSelect.addEventListener('change', function () {
      state.plan = 'subscribe';
      planButtons.forEach(function (btn) {
        var isSub = btn.getAttribute('data-plan') === 'subscribe';
        btn.classList.toggle('plan-box--selected', isSub);
        btn.setAttribute('aria-checked', isSub ? 'true' : 'false');
      });
      render();
    });
  }

  // Add-to-cart loading feedback. Both #offer and the sticky bar button are
  // plain anchor-tag navigations straight into /cart/clear → /cart/add →
  // /checkout, not an AJAX call — there's nothing to await, so this can't
  // preventDefault or it would break the actual add-to-cart. It just gives
  // instant visual feedback for the real (if brief) gap between the click
  // and the browser actually leaving this page, since a silent click is
  // easy to mistake for nothing having happened. Clicking either control
  // marks BOTH as loading, since they point at the same checkout and a
  // shopper could have both on screen at once (desktop CTA + a still-visible
  // sticky bar, or vice versa on mobile).
  var addToCartLinks = [ctaLink, stickyBtn].filter(Boolean);
  addToCartLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      addToCartLinks.forEach(function (l) {
        l.classList.add('is-loading');
        l.setAttribute('aria-busy', 'true');
        var spinner = l.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');
      });
    });
  });
  // Guards against a stuck spinner if the shopper hits Back after checkout
  // and the browser restores this page from cache instead of reloading it.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    addToCartLinks.forEach(function (l) {
      l.classList.remove('is-loading');
      l.removeAttribute('aria-busy');
      var spinner = l.querySelector('.loading__spinner');
      if (spinner) spinner.classList.add('hidden');
    });
  });

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.querySelector('img').getAttribute('src');
      if (!mainImage || mainImage.getAttribute('src') === full) return;

      mainImage.classList.add('is-swapping');
      window.setTimeout(function () {
        mainImage.setAttribute('src', full);
        mainImage.classList.remove('is-swapping');
      }, 160);

      thumbs.forEach(function (t) { t.classList.remove('buybox__thumb--active'); });
      thumb.classList.add('buybox__thumb--active');
    });
  });

  render();
})();
